var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 4.83333H4.33366C3.40024 4.83333 2.93353 4.83333 2.57701 5.01499C2.2634 5.17478 2.00844 5.42975 1.84865 5.74335C1.66699 6.09987 1.66699 6.56658 1.66699 7.5V10.5C1.66699 11.4334 1.66699 11.9001 1.84865 12.2567C2.00844 12.5703 2.2634 12.8252 2.57701 12.985C2.93353 13.1667 3.40024 13.1667 4.33366 13.1667H10.8337M14.167 4.83333H15.667C16.6004 4.83333 17.0671 4.83333 17.4236 5.01499C17.7372 5.17478 17.9922 5.42975 18.152 5.74335C18.3337 6.09987 18.3337 6.56658 18.3337 7.5V10.5C18.3337 11.4334 18.3337 11.9001 18.152 12.2567C17.9922 12.5703 17.7372 12.8252 17.4236 12.985C17.0671 13.1667 16.6004 13.1667 15.667 13.1667H14.167M14.167 16.5L14.167 1.5M16.2503 1.50001L12.0837 1.5M16.2503 16.5L12.0837 16.5",
    stroke: "currentColor",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextInput);
export default __webpack_public_path__ + "static/media/text-input.406868cad6c66979ce21e5a2a3126f28.svg";
export { ForwardRef as ReactComponent };